import React from "react";
import {DatePicker, Form, Input, notification} from "antd";
import classes from "./GetInTouch.module.scss";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton";
import {useChatContext} from "@/app/context/ChatContext";
import {getCookie} from "cookies-next";
import {useRouter} from "next/navigation";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {useAppContext} from "@/app/context/UserContext";

const {TextArea} = Input;
const GetInTouch = ({item, closeModal, getInitials}) => {

    const router = useRouter();
    const {setActiveConversation} = useChatContext();
    const {user} = useAppContext();
    const {t} = useTranslation();
    const [api, contextHolder] = notification.useNotification();
    const openNotification = (type, placement, text) => {
        api[type]({
            message: `${type === 'error' ? t('notifications.error') : t('notifications.success')}`,
            description: text,
            placement,
        });
    };

    const handleCloseModal = () => {
        closeModal();
    }

    const sendMessageToMediator = async (values) => {
        const {message, budget, deadline} = values;
        const formattedDeadline = deadline.format('YYYY-MM-DD');

        const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/get-in-touch`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${getCookie('jwt')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: item.id,
                message,
                budget,
                deadline: formattedDeadline
            })
        });

        if (response.ok) {
            setActiveConversation(item);
            closeModal();
            router.push('/messages');
        } else {
            openNotification('error', 'bottomRight', t('notifications.error'))
        }
    };

    return (<>
            {contextHolder}
            <div className={classes.form}>
                <div className={classes.chatContainer}>
                    <h3 className={classes.title}>Get in touch with</h3>
                    <div className={classes.initials}>{getInitials(item.name)}</div>
                    <span className={classes.title}>{item.name}</span>
                    <div className={classes.line}></div>
                </div>
                <Form onFinish={sendMessageToMediator}>
                    <label className={classes.label}>{t('placeholders.message')}</label>
                    <Form.Item
                        name="message"
                        rules={[
                            {required: true},
                            {max: 500}
                        ]}
                    >
                        <Input.TextArea className={classes.message}
                                        placeholder={t('placeholders.messageDescription')}></Input.TextArea>
                    </Form.Item>

                    <label className={classes.label}>{t('placeholders.budget')}</label>
                    <Form.Item
                        name="budget"
                        rules={[
                            {required: true},
                            {
                                validator: (_, value) =>
                                    value && value > 0 && value <= 10000
                                        ? Promise.resolve()
                                        : Promise.reject(value <= 0
                                            ? t('errors.budget')
                                            : t('errors.maxBudget'))
                            }
                        ]}
                    >
                        <Input addonAfter="€" placeholder={t('placeholders.budget')}></Input>
                    </Form.Item>

                    <label className={classes.label}>{t('placeholders.deadline')}</label>
                    <Form.Item
                        name="deadline"
                        rules={[{required: true}]}
                    >
                        <DatePicker className={classes.datePicker} placeholder={t('placeholders.bidDeadline')}
                                    format="YYYY-MM-DD"
                                    disabledDate={(current) => current && current < moment().startOf('day')}
                        />
                    </Form.Item>

                    <div className={classes.buttons}>
                        <RoundedButton
                            className={classes.cancelButton}
                            onClick={handleCloseModal}
                        >
                            {t('buttons.close')}
                        </RoundedButton>
                        <RoundedButton
                            htmlType='submit'
                            type="primary"
                            isWhite={false}>
                            {t('buttons.send')}
                        </RoundedButton>
                    </div>
                </Form>
            </div>
        </>
    )
}

export default GetInTouch;